import { api } from '@/services'

export const customPayment = (params) => {
    return api.post('admin/payment/customPayment', params)
}
export const chargebackPayment = (params) => {
    return api.post('admin/payment/chargebackPayment', params)
}
export const getAppointmentItemReason = () => {
    return api.get('admin/appointmentItemReason/list')
}
export const calculatePayment = (params) => {
    return api.post('admin/payment/calculatePayment', params)
}
export const getPaymentFinancialDetails = (paymentId) => {
    return api.get(`admin/payment/${paymentId}/financialDetails`)
}
